module.exports = __webpack_public_path__ + "media/books/BookCoverPreview-616d725d.png";